export enum UserStatus {
  Inactive = 'inactive',
  Active = 'active',
  InviteSend = 'inviteSend',
	Blocked = "blocked",
	BlockedInProgress = "blockedInProgress",
}